(function () {

    'use strict';
    angular.module('app').controller('ClientGroupController', ClientGroupController);

    ClientGroupController.$inject = [
        '$scope',
        'ClientService',
        '$routeParams',
        '$location',
        'toastr',
        'ConfirmationModalFactory',
        '$timeout',
        'scrollToForm',
        'ViewChangeNotificationFactory',
        'isUniqueService',
        '$rootScope'
    ];

    function ClientGroupController(
        $scope,
        ClientService,
        $routeParams,
        $location,
        toastr,
        ConfirmationModalFactory,
        $timeout,
        scrollToForm,
        ViewChangeNotificationFactory,
        isUniqueService,
        $rootScope
    ) {
        const isSystemAdmin = $rootScope.GlobalProfile.permissionGroup.roles.find(role => role.code === 'ROLE_ADMIN');
        const isCompanyAdmin = $rootScope.GlobalProfile.permissionGroup.roles.find(role => role.code === 'ROLE_COMPANY_ADMIN');

        const vm = this;
        vm.currentUser = $scope.GlobalProfile;
        vm.params = $routeParams || {};
        vm.groupId = vm.params.id || false;
        vm.group = {};
        vm.offices =[];
        vm.companyId = vm.params.companyId || false;
        vm.save = save;
        vm.getAvailableRoles = getAvailableRoles;
        vm.init = init;
        vm.isViewMode = false;
        vm.goTo = goTo;
        vm.changeStatus = changeStatus;
        vm.parseGroupData = parseGroupData; 
        vm.isUnique = isUnique;
        vm.search = search;

        vm.offices =[];
        let roleGroupsTemp = null; 

        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const toInactiveConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_GROUP_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const toActiveConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_GROUP_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        init();

        function init() {
            vm.isFetching = true;

            if (vm.groupId) {
                ClientService.Group.get(vm.groupId, function (data) {
                    vm.group = data;
                    vm.origGroupName = data.name;
                    vm.groupRaw = angular.copy(vm.group);
                    getAvailableRoles();
                    getAvailableOffices();
                });
            } else {
                getAvailableRoles();
                getAvailableOffices();
            }
        }

        function parseGroupData(data, roleGroups) {
            const group = {
                "roles": [],
                "name": data.name,
                "description": data.description,
                "active": !!data.active,
                "offices" : []
            };

            if (data.id)
                group.id = data.id;
            angular.forEach(roleGroups, function (roleGroup) {
                angular.forEach(roleGroup.roles, function (role) {
                    if (role.isSelected)
                        group.roles.push(role.code);
                });
            });
            angular.forEach(data.offices,function(offices){
                group.offices.push(offices.id)
            })
            return group;
        }

        function getAvailableOffices(search){
           
            ClientService.Location.getAll(
                res=>{
                    const offices =  res.content;
                    vm.offices = offices
                    if(!vm.offices.content){
                        vm.searching = false
                    }
                },err=>{
                    console.log(err)
                },{ 'company.id': vm.companyId,name:search })
        }

        function search(data){
            if(!data.length){
                vm.searching = true
                getAvailableOffices(data.search);
                return;
            }
            vm.searching = false
           angular.forEach(data,function(office){
               for(let i =0; i < vm.offices.length;i++){
                   if(vm.offices[i].id === office.id){
                        delete vm.offices[i]
                   }
               }
           })
        }

        function getAvailableRoles() {
            ClientService.Group.getAvailableRoles(
                function (data) {
                    roleGroupsTemp = [
                        {
                            name: 'Administrative Permissions',
                            roles: getAdminPermissions(),
                        },
                        {
                            name: 'Module Permissions',
                            roles: [
                                'ROLE_COMPANY_PENDING_SHIPMENTS', 'ROLE_COMPANY_RECONCILIATIONS', 'ROLE_ORDER_CONSOLIDATION',
                                'ROLE_COMPANY_RETURNS', 'ROLE_CROSS_DOCK', 'ROLE_COMPANY_IN_STORE', 
                            ],
                        },
                        {
                            name: 'Configuration Access Permissions',
                            roles: [
                                'ROLE_COMPANY_SHIPPING_RULES', 'ROLE_COMPANY_PACKAGING', 'ROLE_PACKAGING_LOGIC',
                                'ROLE_COMPANY_RFID_TRACKING', 'ROLE_COMPANY_WAREHOUSES', 'ROLE_COMPANY_INVENTORY',
                                'ROLE_COMPANY_SMS'
                            ],
                        },
                        {
                            name: 'Additional Permissions',
                            roles: [
                                'ROLE_ADMIN_PORTAL_ACCESS','ROLE_COMPANY_SHIPMENT_TRANSFERS', 'ROLE_COMPANY_BREAK_BULK', 
                                'ROLE_COMPANY_DUTIES','ROLE_COMPANY_SSCC_LABELS', 'ROLE_COMPANY_REPORTING_GRAPHS',
                                'ROLE_COMPANY_MULTI_CURRENCY', 'ROLE_DRIVER', 'ROLE_MOBILE_WAREHOUSE', 'ROLE_WMS',
                                'ROLE_CROSS_DOCK_DISPATCHER', 'ROLE_CROSS_DOCK_ONLY', 'ROLE_BASIC_SHIPMENT_REPORTING',
                                'ROLE_PENDING_SHIPMENT'
                            ]
                        }
                    ];

                    if (vm.groupId && vm.group) {
                        angular.forEach(vm.group.roles, function (role) {
                            for (let i = 0; i < data.length; i++) {
                                if (data[i].code === role.code) {
                                    data[i].isChecked = true;
                                }
                            }
                        });
                        plotRoles(data, vm.group, roleGroupsTemp);
                    } else {
                        plotRoles(data, vm.group, roleGroupsTemp);
                    }

                    vm.isFetching = false;
                },
                function (error) {
                    console.log(error);
                    vm.isFetching = false;
                });
        }

        function getAdminPermissions() {
            const defaultAdminPermissions = ['ROLE_COMPANY_ADMIN', 'ROLE_DRIVER', 'ROLE_FLEET_AND_ROUTE_DASHBOARD', 'ROLE_FLEET_AND_ROUTE_ADMIN','ROLE_MARKETING_ADMIN','ROLE_MARKETING_USER'];

            if (isSystemAdmin) {
                return ['ROLE_ADMIN', ...defaultAdminPermissions];
            }

            return defaultAdminPermissions;
        }

        function changeStatus(event) {
            if (!vm.group.active) {
                vm.group.active = true;
                event.preventDefault();
                toInactiveConf.getInstance().result.then(function (cond) {
                    if (cond) {
                        $timeout(function () {
                            vm.group.active = false;
                        });
                    }
                });
            } else if (vm.group.active) {
                vm.group.active = false;
                event.preventDefault();
                toActiveConf.getInstance().result.then(function (cond) {
                    if (cond) {
                        $timeout(function () {
                            vm.group.active = true;
                        });
                    }
                });
            }
        }

        function save(form) {
            form.$setSubmitted();
            const payload = parseGroupData(vm.group, vm.roleGroups);
            if (form.$invalid || !payload.roles.length) {
                if (!payload.roles.length)
                    toastr.warning('Please select at least 1 permission', 'Validation Error');
                scrollToForm(form.$name);
                return;
            }
            payload.companyId = vm.companyId;
            if (payload.id) {
                ClientService.Group.update(
                    payload,
                    function (response) {
                        vm.groupId = response.id;
                        init();
                        toastr.success("Group has been updated");
                    },
                    function (error) {
                        toastr.error(error.message);
                    }, payload.id);
            } else {
                ClientService.Group.create(
                    payload,
                    function (response) {
                        toastr.success("Group has been created");
                        onRouteChangeOff();
                        $location.path(`/clients/${vm.companyId}/group/${response.id}`);
                    },
                    function (error) {
                        toastr.error(error.message)
                    });
            }
        }

        function goTo(path, params) {
            $location.path(path).search(params);
        }

        function plotRoles(roles, group, roleGroups) {
            vm.roleGroups = null;
            angular.forEach(group.roles, function (role) {
                roles.find(function (r) {
                    if (r.code === role.code) {
                        r.isSelected = true;
                        return true;
                    }
                    if (vm.currentUser.permissionGroup.id == vm.groupId && r.code === 'ROLE_ADMIN') {
                        r.isDisabled = true;
                    }
                    return false;
                })
            });
            angular.forEach(roleGroups, function (roleGroup, i) {
                angular.forEach(roleGroup.roles, function (item, o) {
                    roleGroups[i].roles[o] = roles.find(function (role) {
                        return role.code == item;
                    });
                    if (roleGroups[i].name === 'Administrative Permissions') {
                        angular.extend(roleGroups[i].roles[o], {
                            onClick: (group, role) => {
                                $timeout(() => {
                                    if (role.isSelected) {
                                        const selected = group.roles.find(r=>r.isSelected);
                                        group.roles.forEach(r => {
                                            /*['ROLE_ADMIN','ROLE_COMPANY_ADMIN', 'ROLE_DRIVER', 'ROLE_FLEET_AND_ROUTE_DASHBOARD', 'ROLE_FLEET_AND_ROUTE_ADMIN']*/
                                            const isAdmin = r1 => r1.code === 'ROLE_ADMIN'
                                                || r1.code === 'ROLE_COMPANY_ADMIN'
                                                || r1.code === 'ROLE_DRIVER';
                                            if(isAdmin(selected) || isAdmin(role))
                                                r.isSelected = false;
                                        });
                                        role.isSelected = true;
                                    } else {
                                        group.roles.forEach(r => r.isSelected = false);
                                    }
                                });
                            }
                        })
                    }
                });
            });
            vm.roleGroups = angular.copy(roleGroups);
        }

        let onRouteChangeOff = $rootScope.$on('$routeChangeStart', routeChange);
        function routeChange(event, next) {
            let path = next.$$route.originalPath;
            if (isChanged(vm.group, vm.groupRaw)) {
                event.preventDefault();
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChangeOff();
                        if(path.includes(':companyId')) {
                            $location.path(path.replace(':companyId', vm.companyId));
                        }
                        else {
                            $location.path(path);
                        }
                    }
                });
            }
        }

        function isChanged(n, o) {
            return !angular.equals(cleanPayload(n), cleanPayload(o));
        }

        function cleanPayload(data) {
            const {active, description, name, roles} = data;
            return {active, description, name, roles: roles.map(role => role.code || role)};
        }

        function isUnique(model, formField, origVal, prop) {
            let params = {};
            params.model = model;
            params.origName = origVal;
            params.formField = formField;
            params.service = ClientService.Group;
            params.serviceMethod = "getAll";
            params.property = prop;
            params.warningMsg = `Group ${prop} is already taken`;
            isUniqueService.isUnique(params);
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/client/ClientGroupController.js